import { render, staticRenderFns } from "./PrintFolder.vue?vue&type=template&id=3cbfd529&"
import script from "./PrintFolder.vue?vue&type=script&lang=js&"
export * from "./PrintFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports